import * as React from 'react'

import { type Icon } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import NotFound from 'modules/core/components/NotFound'
import i18n from 'modules/core/lib/i18n'

interface Props {
  illustration?: React.ComponentProps<typeof Icon.Large>['icon']
  title?: string
  description?: string
}

const MissingResourceModal = ({
  illustration = 'table-file',
  title = i18n.t('custom_tables.modal.title'),
  description = i18n.t('custom_tables.modal.description'),
}: Props) => {
  return (
    <Modal illustration={illustration} title={title} description={description}>
      <NotFound />
    </Modal>
  )
}

export default observer(MissingResourceModal)
